// Derive a display status for a shift from its raw flags.
// open -> still running, verified -> closed & confirmed, closed -> closed & unconfirmed.
export function deriveShiftStatus(shift) {
  if (!shift?.isFinished) return "open";
  return shift.isVerified ? "verified" : "closed";
}

// Human readable duration between two ISO timestamps. Returns "—" while the
// shift is still open (no end time recorded yet).
export function formatShiftDuration(startTime, endTime) {
  if (!startTime || !endTime) return "—";
  const start = new Date(startTime).getTime();
  const end = new Date(endTime).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) return "—";

  const totalMinutes = Math.floor((end - start) / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
}

// Cash variance = counted closing cash minus what the system expected.
export function shiftCashVariance(shift) {
  if (typeof shift?.closingCash !== "number" || typeof shift?.expectedCash !== "number") {
    return null;
  }
  return shift.closingCash - shift.expectedCash;
}
